import { useState } from 'react';
import { Navbar } from '@/components/Navbar';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { AccessRequestsTab } from '@/components/admin/AccessRequestsTab';
import { UsersTab } from '@/components/admin/UsersTab';

export function Admin() {
  const [activeTab, setActiveTab] = useState('users');

  return (
    <div className="min-h-screen bg-background">
      <Navbar />

      <div className="container mx-auto px-4 py-8">
        <div className="space-y-6">
          <div>
            <h1 className="text-3xl font-bold tracking-tight">Admin Panel</h1>
            <p className="mt-2 text-muted-foreground">Manage users and access requests</p>
          </div>

          <Tabs value={activeTab} onValueChange={setActiveTab} className="space-y-4">
            <TabsList>
              <TabsTrigger value="users">Users</TabsTrigger>
              <TabsTrigger value="requests">Access Requests</TabsTrigger>
            </TabsList>

            <TabsContent value="users" className="space-y-4">
              <UsersTab />
            </TabsContent>

            <TabsContent value="requests" className="space-y-4">
              <AccessRequestsTab />
            </TabsContent>
          </Tabs>
        </div>
      </div>
    </div>
  );
}
